import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss'],
})
export class CustomersListComponent {
  url: string = 'users';
  data: Array<any> = [];
  totalCustomers = 0;
  totalActivos = 0;
  totalInactivos = 0;
  ultimoRegistro = '-';
  totalNumber = 0;
  byCities = 0;
  filter = 2;
  totalBussines = 0;
  resumenCards = [
    {
      //label: 'TN',
      value: 0,
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Individuals',
    },
    {
      //label: 'TN',
      value: 0,
      icon: 'fas fa-building',
      bgClass: 'bg-white',
      desc: 'Business',
    },
    {
      //label: 'TN',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Customers',
    },
    {
      //label: 'BC',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Cities',
    },
  ];

  resumenCardsTwo = [
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];
  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService.getData(`${this.url}/customers`).subscribe((response) => {
      //  this.dataService.getData(`${this.url}`).subscribe((response) => {
      console.log('response en customers', response);
      if (response.rst) {
        this.data = response.data;
        this.filteredData = [...this.data];
        this.getStats();
        this.getResumenEstados();
        this.actualizarSugerencias();
      } else {
        this.messageService.add(response.msg, 'secondary');
      }
    });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  getStats() {
    this.totalCustomers = this.data.filter(
      (res) => res.bussines_name === '',
    ).length;
    //this.totalCustomers = this.data.filter(res => !res.bussines_name).length;
    this.totalBussines = this.data.filter(
      (res) => res.bussines_name && res.bussines_name.trim() !== '',
    ).length;
    this.totalActivos = this.data.filter((d) => d.status).length;
    this.totalInactivos = this.data.filter((d) => !d.status).length;
    this.ultimoRegistro = this.data.length
      ? this.data[this.data.length - 1].firstname +
        ' ' +
        this.data[this.data.length - 1].lastname
      : '-';
  }

  getResumenEstados() {
    this.totalNumber = this.data.length;
    //this.byCities = new Set(this.data.map((d) => d.city)).size;
    this.byCities = new Set(
      this.data.map((d) => d.city).filter((c) => c && c.trim() !== ''),
    ).size;

    this.resumenCards[0].value = this.totalCustomers;
    this.resumenCards[1].value = this.totalBussines;
    this.resumenCards[2].value = this.totalActivos;
    //this.resumenCards[4].value = this.totalInactivos;
  }

  filtrarConductores() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto)) ||
          (item.phone && item.phone.toLowerCase().includes(texto)) ||
          (item.role &&
            item.role.name &&
            item.role.name.toLowerCase().includes(texto)) ||
          (item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          (item.state && item.state.toLowerCase().includes(texto)) ||
          (item.city && item.city.toLowerCase().includes(texto))
        );
      });
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    //this.totalCustomers = this.filteredData.length;
    this.totalCustomers = this.filteredData.filter(
      (res) => res.bussines_name === '',
    ).length;
    //this.totalCustomers = this.filteredData.filter(res => !res.bussines_name).length;
    this.totalBussines = this.data.filter(
      (res) => res.bussines_name && res.bussines_name.trim() !== '',
    ).length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-';
  }

  getResumenEstadosFiltrado() {
    this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;

    this.resumenCards[0].value = this.totalCustomers;
    this.resumenCards[1].value = this.totalBussines;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.byCities;
    //this.resumenCards[4].value = this.totalInactivos;
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.firstname) sugerenciasSet.add(item.firstname);
      if (item.lastname) sugerenciasSet.add(item.lastname);
      if (item.phone) sugerenciasSet.add(item.phone);
      if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      if (item.rol_user) sugerenciasSet.add(item.rol_user);
      if (item.state) sugerenciasSet.add(item.state);
      if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }
}
